module.exports = __webpack_public_path__ + "img/banner1.d55e9c4d.jpg";